import React from "react";
import { Modal } from "antd";
import styles from "./index.module.scss";
import { useCurrent } from "@/providers";
import { get } from "lodash-es";

const PayModal = (props: any) => {
  const {
    open,
    onCancel,
    onOk,
    showTitle = true,
    tipText = "尊敬的用户，您还不是企采商高级会员",
    descText,
  } = props;
  const { current, customerInfo } = useCurrent();
  const companyName =
    get(customerInfo, "comName") ||
    get(current, "mainAccount.attributes.companyName") ||
    "-";
  return (
    <Modal
      title={<div className={styles.payModalTitle}>{companyName}</div>}
      open={open}
      onCancel={onCancel}
      onOk={onOk}
      centered
      width={560}
      wrapClassName={styles.payModal}
      footer={null}
    >
      <div className={styles.modalContent}>
        <div className={styles.modalContentTitle}>
          <div className={styles.modalContentTitleTip}>{tipText}</div>
          <div className={styles.modalContentTitleTipDesc}>
            {descText ||
              (showTitle && (
                <>
                  成为<span style={{ color: "#1D1D1F" }}>高级企采商会员</span>
                  后，可以发送名片给买家
                </>
              ))}
          </div>
        </div>
        <div className={styles.modalOperateBox}>
          <div className={styles.modalOperateBoxLeft}>
            <span className={styles.modalOperateBoxLeftTitle}>
              高级企采商
            </span>
            <span className={styles.modalOperateBoxLeftDesc}>
              未购买相关服务，请先购买高级企采商
            </span>
          </div>
          <div
            className={styles.modalOperateBoxRight}
            onClick={() => {
              window.open(`${process.env.YCX_HOME}/go/portal/e-goods?id=1`);
            }}
          >
            立即购买
            <img
              src="https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/rightArrowO.png"
              style={{ width: 16, height: 16 }}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PayModal;
